exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr{border-color:#9b9b9b}.info-passengers{background-color:#f1f2f8;display:flex;flex-direction:column;min-height:80vh;width:100%;padding:1rem 1rem 3rem;margin:auto}@media (min-width:1024px){.info-passengers{padding-bottom:5rem}}.info-passengers .input-group{width:100%}.class-login{justify-content:center;background-color:transparent;background-image:url(/img/area-reserva-img.webp)}@media (max-width:600px){.class-login{background-image:url(/img/area-reserva-img-mobile.webp)}}.slide-fade-enter-active{transition:all .3s ease}.slide-fade-leave-active{transition:all .5s cubic-bezier(1,.5,.8,1)}.slide-fade-enter,.slide-fade-leave-to{transform:translateX(200px);opacity:0}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};